import Stack from '@mui/material/Stack';
import { useMemo } from 'react';
import { useFiltersContext } from '../context/FiltersContext';
import { ClearFiltersButton } from './components/ClearFiltersButton';
import { FiltersBarScrollableWrapper } from './components/FiltersBarScrollableWrapper';
import { MoreFilters } from './components/moreFilters/MoreFilters';
import { SingleFiltersList } from './components/SingleFiltersList';
import { filterVisibleFilters } from './utils';

export const FiltersBar = <Criteria extends Record<string, string | string[]>>() => {
  const { filtersConfig, visibleFilters } = useFiltersContext<Criteria>();

  const { filteredVisibleFilters, moreFilters } = useMemo(
    () => filterVisibleFilters<Criteria>(filtersConfig, visibleFilters),
    [filtersConfig, visibleFilters]
  );

  return (
    <FiltersBarScrollableWrapper>
      <Stack
        direction="row"
        spacing={1}
        data-test="filters-bar"
        sx={{
          alignItems: 'center',
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        <SingleFiltersList filters={filteredVisibleFilters} />

        {moreFilters.length > 0 && <MoreFilters filters={moreFilters} />}
        <ClearFiltersButton />
      </Stack>
    </FiltersBarScrollableWrapper>
  );
};
